/* eslint-disable import/no-anonymous-default-export */
import {combineReducers} from 'redux'
import {persistReducer} from 'redux-persist'
import configureStore from './CreateStore'
import rootSaga from '../Sagas/'
import {createBrowserHistory} from 'history'
import ReduxPersist from '../Config/ReduxPersist'
import {connectRouter} from 'connected-react-router'
export const history = createBrowserHistory()

/* ------------- Assemble The Reducers ------------- */

export const reducers = combineReducers({
  auth: require('./AuthRedux').reducer,
  startup: require('./StartupRedux').reducer,
  nav: require('./NavRedux').reducer,
  router: connectRouter(history),
  filters: require('./FiltersRedux').reducer,
  adLibrary: require('./AdLibraryRedux').reducer,
  watchList: require('./WatchListRedux').reducer,
  calculators: require('./CalculatorsRedux').reducer,
  publications: require('./PublicationsRedux').reducer,
  moreAds: require('./MoreAdsRedux').reducer,
  charts: require('./ChartsRedux').reducer,
  advertisers: require('./AdvertisersRedux').reducer,
  folders: require('./FoldersRedux').reducer,
  filtersTopPerforming: require('./FiltersTopPerformingRedux').reducer,
  filtersInterest: require('./FiltersInterestRedux').reducer,
  interests: require('./InterestsRedux').reducer,
  topPerforming: require('./TopPerformingRedux').reducer,
  topPerformingAdmin: require('./TopPerformingAdminRedux').reducer,
  suggestHelpAdmin: require('./SuggestHelpAdminRedux').reducer,
  reportAdmin: require('./ReportAdminRedux').reducer,
  lists: require('./ListsRedux').reducer,
  publicationCreate: require('./PublicationCreateRedux').reducer,
  feedback: require('./SuggestHelpRedux').reducer,
  settings: require('./SettingsRedux').reducer,
  permissions: require('./PermissionsRedux').reducer,
  billingHistory: require('./BillingHistoryRedux').reducer,
  notifications: require('./NotificationsRedux').reducer,
  customers: require('./CustomersRedux').reducer,

  errors: require('./ErrorsRedux').reducer,
  users: require('./UserRedux').reducer,
  //processes: require('./ProcessRedux').reducer,
  // roles: require('./RoleRedux').reducer,
  //templates: require('./TemplateRedux').reducer,
  //langs: require('./LangRedux').reducer,
})

export default preloadedState => {
  let finalReducers = reducers

  if (ReduxPersist.active) {
    const persistConfig = ReduxPersist.storeConfig
    finalReducers = persistReducer(persistConfig, reducers)
  }

  let {store, sagasManager, sagaMiddleware} = configureStore(finalReducers, rootSaga, history, preloadedState)

  if (module.hot) {
    module.hot.accept(() => {
      const nextRootReducer = require('./').reducers
      store.replaceReducer(nextRootReducer)

      const newYieldedSagas = require('../Sagas').default
      sagasManager.cancel()
      sagasManager.done.then(() => {
        sagasManager = sagaMiddleware.run(newYieldedSagas)
      })
    })
  }

  return store
}
